(() => {
  const main = document.getElementById('MainContent');
  if (!main || (!main.classList.contains('ink-deal-page') && !main.classList.contains('ink-deals-collection'))) return;
  main.dataset.inkDealUnified = 'true';

  const toolbar = main.querySelector('[data-ink-deals-toolbar]');
  if (!toolbar) return;
  const kinds = ['all', 'vinyl', 'roll', 'clear', 'holographic'];
  const initial = new URL(window.location.href).searchParams.get('deal_type');
  const country = new URL(window.location.href).searchParams.get('country');
  let selected = kinds.includes(initial) ? initial : 'all';
  const matches = (handle, kind) => {
    const roll = handle.includes('roll-labels');
    const clear = handle.includes('clear');
    const holographic = handle.includes('holographic');
    if (kind === 'all') return true;
    if (kind === 'roll') return roll;
    if (kind === 'clear') return clear;
    if (kind === 'holographic') return holographic;
    return !roll && !clear && !holographic;
  };
  const apply = () => {
    const cards = [...main.querySelectorAll('[data-ink-deal-card]')];
    let count = 0;
    cards.forEach(card => {
      const show = matches(card.dataset.productHandle || '', selected);
      card.hidden = !show;
      if (show) count += 1;
    });
    toolbar.querySelectorAll('[data-ink-deal-filter]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.inkDealFilter === selected));
    });
    const status = toolbar.querySelector('[data-ink-deal-count]');
    const text = (count === 1 ? toolbar.dataset.countSingle : toolbar.dataset.countPlural).replace('__COUNT__', String(count));
    if (status && status.textContent !== text) status.textContent = text;
    main.dataset.inkDealFilter = selected;
    const url = new URL(window.location.href);
    if (selected === 'all') url.searchParams.delete('deal_type');
    else url.searchParams.set('deal_type', selected);
    if (country) url.searchParams.set('country', country);
    if (url.href !== window.location.href) window.history.replaceState(null, '', url);
  };
  toolbar.addEventListener('click', event => {
    const button = event.target.closest('[data-ink-deal-filter]');
    if (!button) return;
    selected = button.dataset.inkDealFilter;
    const url = new URL(window.location.href);
    if (selected === 'all') url.searchParams.delete('deal_type');
    else url.searchParams.set('deal_type', selected);
    window.history.replaceState(null, '', url);
    apply();
  });
  window.addEventListener('popstate', () => {
    const value = new URL(window.location.href).searchParams.get('deal_type');
    selected = kinds.includes(value) ? value : 'all';
    apply();
  });
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; apply(); });
  }).observe(main, { childList: true, subtree: true });
  apply();
})();
